module.exports = __webpack_public_path__ + "img/about_img2.5efb21a6.png";